import React from 'react';
import ReactDom from 'react-dom';

const ScanMarker = () => <div className="scan-marker" />;

const scanMaker = document.createElement('div');

ReactDom.render(<ScanMarker />, scanMaker);

export default scanMaker;
